import { VueNodeViewRenderer } from '@tiptap/vue-3';
import GenericMediaComponent from './GenericMedia.vue';
import GenericMediaPlaceholderComponent from './GenericMediaPlaceholder.vue';
import {
  InlineMediaType,
  GenericMediaNode as BaseGenericMediaNode,
  GenericMediaPlaceholder as BaseGenericMediaPlaceholder,
} from '@superthread-com/extension-inline-media/src/index';

export const GenericMediaNode = BaseGenericMediaNode.extend({
  addNodeView() {
    return VueNodeViewRenderer(GenericMediaComponent as any);
  },
});

export const GenericMediaPlacholder = BaseGenericMediaPlaceholder.extend({
  addNodeView() {
    return VueNodeViewRenderer(GenericMediaPlaceholderComponent as any);
  },
});

export { InlineMediaType };
